module.exports = __webpack_public_path__ + "media/checkmarks/grey-checkmark-a1b1df36.svg";